import { onApiError } from "../error"
import { objectToQueryString } from "../utils"
import { del, get, post, put } from "./client"

/**
 * @param {string} imsi
 */
async function delFarmcamSim(imsi) {
    const res = await del(`/farmcam-sims/${imsi}`)
    if (!res.ok) throw await onApiError(res)
}

/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */
async function delFarmcamSimSubscription(imsi) {
    const res = await del(`/farmcam-sims/${imsi}/subscription`)
    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */
async function getFarmcamSim(imsi) {
    const res = await get(`/farmcam-sims/${imsi}`)

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @typedef {Object} RemainingDataDataPoint
 * @property {string} Imsi
 * @property {number} RemainingData
 * @property {string} Timestamp
 */

/**
 * @param {string} imsi
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<RemainingDataDataPoint[]|Blob>}
 */
async function getFarmcamSimRemainingData(imsi, args) {
    const params = objectToQueryString(args)
    const res = await get(`/farmcam-sims/${imsi}/remaining-data${params}`)

    if (!res.ok) throw await onApiError(res)
    if (!args || args.format === "json") return res.json()
    return res.blob()
}

/**
 * @param {string} imsi
 * @returns {Promise<FarmcamSim>}
 */
async function postFarmcamSimData(imsi) {
    const res = await post(`/farmcam-sims/${imsi}/data`)

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {string} imsi
 * @param {PutFarmcamSimParams} args
 * @returns {Promise<FarmcamSim>}
 */
async function putFarmcamSim(imsi, args) {
    const res = await put(`/farmcam-sims/${imsi}`, {
        body: JSON.stringify(args)
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {string} imsi 
 * @param {string} email 
 * @returns {Promise<FarmcamSim>}
 */
async function putFarmcamSimOwner(imsi, email) {
    const res = await put(`/farmcam-sims/${imsi}/owner`, {
        body: JSON.stringify({
            Email: email
        })
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {string} imsi
 * @param {number} bytes
 * @param {number} days
 * @returns {Promise<FarmcamSim>}
 */
async function putFarmcamSimTrial(imsi, bytes, days) {
    const res = await put(`/farmcam-sims/${imsi}/trial`, {
        body: JSON.stringify({
            Bytes: bytes,
            Days: days,
        })
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

export {
    delFarmcamSim,
    delFarmcamSimSubscription,
    getFarmcamSim,
    getFarmcamSimRemainingData,
    postFarmcamSimData,
    putFarmcamSim,
    putFarmcamSimOwner,
    putFarmcamSimTrial,
}